import { jsx as _jsx } from "react/jsx-runtime";
import { openCookiePreferences } from './store.js';
/** Opens the cookie preferences dialog (BR-6). A button, since it opens a dialog rather than navigating. */
export function CookiePreferencesLink({ className, style, children = 'Cookie preferences', 'data-testid': testId = 'cookie-preferences-link', }) {
    return (_jsx("button", { type: "button", className: className, style: style, "data-testid": testId, onClick: openCookiePreferences, children: children }));
}
//# sourceMappingURL=CookiePreferencesLink.js.map